import { lazy } from 'react';

import { sentenceCase } from 'change-case'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { useAppRoutes } from '@webapp/hooks'
import messages from './messages'
import { type IPunchOutGroupConnectionLogsPageProps } from './types'

const PunchOutGroupConnectionLogsViewChunk = lazy(() =>
  import('../feature-sets/PunchOutGroupConnectionLogsView').then(
    ({ PunchOutGroupConnectionLogsView }) => ({
      default: PunchOutGroupConnectionLogsView,
    })
  )
)

export const PunchOutGroupConnectionLogsPage = (
  props: IPunchOutGroupConnectionLogsPageProps
) => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  const { supplier, groupId } = props.match.params

  return (
    <Page
      pageTitle={intl.formatMessage(
        messages.punchOutGroupConnectionLogsPageTitle
      )}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsPageTitle),
        },
        {
          link: url('PunchOutSuppliersPage', { supplier: '' }),
          name: intl.formatMessage(messages.punchOutSuppliersPageTitle),
        },
        {
          link: url('PunchOutGroupPage', { supplier, group: groupId }),
          name: sentenceCase(supplier),
        },
        {
          name: intl.formatMessage(
            messages.punchOutGroupConnectionLogsPageTitle
          ),
        },
      ]}
    >
      <PunchOutGroupConnectionLogsViewChunk />
    </Page>
  )
}
